import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharePendingRequest } from '@portal-core/util/observables.decorators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssetsFileApiService {
  constructor(private http: HttpClient) { }

  /**
   * Loads the file from the assets folder.
   * @param filePath The path to the file relative to the assets folder. For example, for a file located at `src/assets/data/file.json`, the `filePath` would be `data/file.json`.
   *  */
  @SharePendingRequest()
  getFile$<T>(filePath: string): Observable<T> {
    return this.http.get<T>(`assets/${filePath}`);
  }

  /**
   * Loads the file from the assets folder and returns its content as a string value.
   * @param filePath The path to the file relative to the assets folder. For example, for a file located at `src/assets/data/file.json`, the `filePath` would be `data/file.json`.
   *  */
  @SharePendingRequest()
  getTextFile$(filePath: string): Observable<string> {
    return this.http.get(`assets/${filePath}`, { responseType: 'text' });
  }
}
